module.exports = __webpack_public_path__ + "img/OurJourney2018.de6e1856.png";